<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Transferencias BI
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>Realizar Transferencia
			</label>

			<input type="radio" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL" name="pcss3t"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5028,5028]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-book-bookmark"></i>Historial de Transferencias
			</label>

		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-bi-transfer-transaction *ngIf="history==0"></app-bi-transfer-transaction>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-bi-transfer-history *ngIf="history==1"></app-bi-transfer-history>
			</div>
		</div>
	</div>

</div>